import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Badge from './Badge';
import Translate, { translate } from './Translate';
import Icon from './Icon';

const FiltersToggleButton = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

FiltersToggleButton.defaultProps = {
    display: 'flex',
    flex: ['1 0 40%', '0 1 auto'],
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'stretch',
    paddingX: 'md',
    paddingY: 'sm',
    margin: ['0 0 10px 0', '0 10px 0 0'],
    fontSize: 'inherit',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
    textAlign: 'center',
    color: 'body',
    bgColor: 'gray100',
    minHeight: '40px',
};

@inject('translationStore')
class FiltersToggle extends React.Component<any> {
    render() {
        const {
            theme,
            translationStore,
            onClick,
            filtersActive,
            filtersCount,
        } = this.props;
        return (
            <FiltersToggleButton
                title={translate(translationStore, 'Filters')}
                onClick={onClick}
                {...theme.FiltersToggleButton}
            >
                <Icon
                    fileName="MenuIcon"
                    height="1.4em"
                    width="1.4em"
                    margin="0 0.5em 0 0"
                    {...theme.FiltersToggleButtonIcon}
                />
                <Translate>Filters</Translate>
                {filtersActive && (
                    <Badge
                        marginX="sm"
                        bgColor="primary"
                        {...theme.FiltersToggleBadge}
                    >
                        {filtersCount}
                    </Badge>
                )}
            </FiltersToggleButton>
        );
    }
}

export default observer(withTheme(FiltersToggle)) as any;



// WEBPACK FOOTER //
// ./src/Components/FiltersToggle.tsx